import React from "react";
import { Satellite } from "lucide-react";
import { MARQUEE_ITEMS } from "../content";

export const Marquee = () => (
  <div className="relative border-y border-white/10 bg-[#0B0E14]/60 py-5 overflow-hidden" data-testid="marquee">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {MARQUEE_ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center gap-6 px-6 whitespace-nowrap">
              <span className="font-display text-sm sm:text-base font-semibold tracking-[0.2em] text-slate-400 uppercase">
                {item}
              </span>
              <Satellite size={14} className="text-cyan-500/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
